import { FormField } from '@/components/UI/FormFields';
import { _get } from '@/littledash';
import type { FC } from 'react';
//@ts-expect-error - old hook form - replace with `react-hook-form@latest`
import type { ValidationRule } from 'react-hook-form';
//@ts-expect-error - old hook form - replace with `react-hook-form@latest`
import { Controller, ControllerRenderProps, useFormContext } from 'react-hook-form';
import { getRegisterConfig } from './FormField.utils';
import { ONLY_DIGITS_REGEX } from '@/validators.constants.ts';

interface DigitsOnlyFieldProps {
  value?: string;
  name: string;
  label: string;
  disabled?: boolean;
  hint?: string;
  required?: ValidationRule<boolean>;
  placeholder?: string;
  maxLength?: number;
  autoFocus?: boolean;
  testId?: string;
}

/**
 * A text input field that only accepts digits (0-9)
 * No negative numbers, decimals, or scientific notation allowed
 * Built on top of text input to avoid HTML5 number input quirks with "e" scientific notation
 */
export const DigitsOnlyField: FC<DigitsOnlyFieldProps> = ({
  value,
  name,
  label,
  disabled = false,
  hint,
  required,
  placeholder,
  maxLength,
  autoFocus,
  testId = 'digits-only-field',
}) => {
  const {
    control,
    formState: { errors },
    trigger,
  } = useFormContext();
  const rules = getRegisterConfig({
    required,
    pattern: {
      value: ONLY_DIGITS_REGEX,
      message: 'Must contain only digits',
    },
    maxLength,
  });
  const isError = _get(errors, name);

  return (
    <FormField label={label} name={name} hint={hint} required={required} testPrefix={testId}>
      <div data-test-component="DigitsOnlyField">
        <Controller
          name={name}
          control={control}
          defaultValue={value}
          rules={rules}
          render={({ onChange, value }: ControllerRenderProps) => {
            const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
              onChange(event.target.value);
              trigger(name);
            };

            return (
              <input
                id={name}
                type="text"
                inputMode="numeric"
                onChange={handleChange}
                value={value}
                className={isError ? 'input__error' : ''}
                disabled={disabled}
                style={{ marginBottom: 0 }}
                placeholder={placeholder}
                autoFocus={autoFocus}
                data-test-element="input"
                data-testid={testId}
              />
            );
          }}
        />
      </div>
    </FormField>
  );
};
